import { DualValueCard as CXDualValueCard } from '@sanlamcx/react-ui-next-dual-value-card';

export const DualValueCard = CXDualValueCard;
